(function() {
    'use strict';

    angular
        .module('telestatApp')
        .factory('SimPhoneSearch', SimPhoneSearch);

    SimPhoneSearch.$inject = ['$resource'];

    function SimPhoneSearch($resource) {
        var resourceUrl =  'api/_search/sim-phones/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
